import { Component, inject } from '@angular/core';
import { NozzleService } from '../proxy/general/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  NozzleCreateDto,
  NozzleDto,
  NozzleExcelDownloadDto,
  NozzleUpdateDto,
} from '../proxy/general/dtos/nozzle';
import { NOZZLE_CONFIG, NOZZLE_FIELDS } from './nozzle.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-nozzle',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, NozzleService, ConfirmationService],
  templateUrl: './nozzle.html',
  styleUrl: './nozzle.scss',
})
export class Nozzle extends BaseCrudComponent<
  NozzleDto,
  NozzleCreateDto,
  NozzleUpdateDto,
  NozzleExcelDownloadDto
> {
  service = inject(NozzleService);
  config = NOZZLE_CONFIG;
  fields = NOZZLE_FIELDS;

  protected prepareUpdateDto(data: any, selected: NozzleDto): NozzleUpdateDto {
    return {
      modelId: data.modelId,
      flow: data.flow,
      color: data.color,
      pressure: data.pressure,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Nozzle';
  }
}
